// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c12e6217","41":"b409466f","44":"bef7e72d","48":"18020e96","430":"3f3949e0","562":"bbc5b783","728":"a121504c","741":"ac555718","776":"98408c0b","804":"f7bd293a","832":"3c8cb405","879":"820f38ed","974":"94c1f710","977":"20a07eb2"}[chunkId] + ".chunk.js";
};